import { ALL_SCHEMES } from "../../constants";
import { useCodeFont } from "../../hooks/useCodeFont";
import { useCodeSchemeName } from "../../hooks/useCodeSchemes";
import { useCodeTextSize } from "../../hooks/useCodeTextSize";
import { CodeFontPicker } from "../CodeFontPicker";
import { CodeTextSize } from "../CodeTextSize";
import { CodeThemePicker } from "../CodeThemePicker";
import styles from "./CodeSettings.module.css";

/**
 * A settings panel for the TechDocs code viewer.
 *
 * Composes {@link CodeThemePicker}, {@link CodeFontPicker}, and
 * {@link CodeTextSize} under a "Code Viewer" group label. Each picker is
 * connected to its corresponding persisted-setting hook:
 * {@link useCodeSchemeName}, {@link useCodeFont}, and {@link useCodeTextSize}.
 *
 * Intended to be mounted as a TechDocs addon settings panel.
 *
 * @public
 */
export const CodeSettings = () => {
    const [schemeName, setSchemeName] = useCodeSchemeName();
    const font = useCodeFont();
    const textSize = useCodeTextSize();

    return (
        <>
            <span className={styles.groupLabel}>Code Viewer</span>

            <CodeThemePicker
                schemes={ALL_SCHEMES}
                value={schemeName}
                onChange={setSchemeName}
            />
            <CodeFontPicker
                fontLabel={font.fontLabel}
                onChange={font.handleFontChange}
            />
            <CodeTextSize
                size={textSize.size}
                onSizeCommitted={textSize.handleSizeCommitted}
                onDecrease={textSize.handleDecrease}
                onIncrease={textSize.handleIncrease}
            />
        </>
    );
};
